(() => {
 if(customElements.get('ulg-size-guide'))return;
 customElements.define('ulg-size-guide',class extends HTMLElement{
  async connectedCallback(){
   if(this.initialized)return;this.initialized=true;
   this.dialog=this.querySelector('dialog');this.trigger=this.querySelector('.ulg-size-guide__trigger');
   if(!this.dialog||!this.trigger)return;
   const slot=document.querySelector('[data-ulg-size-guide-slot][data-product-id="'+this.dataset.productId+'"]');
   if(slot){slot.append(this);slot.hidden=false;}
   else{const host=document.querySelector('.product-single__meta');if(host)host.append(this);}
   this.hidden=false;
   if(this.dataset.replaceKiwi==='true')document.documentElement.classList.add('ulg-has-size-guide');
   this.measurements=new Map();
   this.trigger.disabled=true;
   try{
    const response=await fetch(this.dataset.unitMapUrl);if(!response.ok)throw new Error('Unit data unavailable');
    const maps=await response.json();
    this.querySelectorAll('[data-guide-panel]').forEach(panel=>{
     const tables=panel.querySelectorAll('table');
     (maps[panel.dataset.guideHandle]||[]).forEach(v=>{
      const cell=tables[v.table]?.rows[v.row]?.cells[v.col];if(!cell)return;
      const text=cell.textContent.trim();
      if(text===v.baseline)this.measurements.set(cell,{cm:v.cm,in:v.in});
      else this.addMeasurement(cell,text,v.base);
     });
    });
   }catch(_){}
   this.trigger.disabled=false;
   this.querySelectorAll('[data-unit-values]').forEach(cell=>{
    try{
     const values=JSON.parse(cell.dataset.unitValues);const text=cell.textContent.trim();
     if(values['0']===undefined||values['1']===undefined)return;
     if(text===String(values['0']).trim()||text===String(values['1']).trim())this.measurements.set(cell,{cm:String(values['1']),in:String(values['0'])});
     else this.addMeasurement(cell,text,'cm');
    }catch(_){}
   });
   this.querySelectorAll('table').forEach(table=>{
    const rows=Array.from(table.rows);if(!rows.length)return;
    Array.from(rows[0].cells).forEach((header,index)=>{
     const label=header.textContent.trim();let base;
     if(/\bcm\b/i.test(label))base='cm';else if(/\bmm\b/i.test(label))base='mm';else if(/\b(?:in|inch|inches)\b|["″]/i.test(label))base='in';
     if(!base)return;
     if(!this.measurements.has(header)&&/\d/.test(label))this.addMeasurement(header,label,base);
     else if(!/\d/.test(label))header.dataset.ulgOriginalLabel=label;
     rows.slice(1).forEach(row=>{const cell=row.cells[index];if(cell&&!this.measurements.has(cell))this.addMeasurement(cell,cell.textContent.trim(),base);});
    });
   });
   let unit=this.dataset.defaultUnit==='in'?'in':'cm';
   try{const saved=localStorage.getItem('ulg-size-guide-unit');if(saved==='cm'||saved==='in')unit=saved;}catch(_){}
   this.setUnit(unit,false);
   this.trigger.addEventListener('click',()=>{if(this.dialog.open)return;this.oldOverflow=document.body.style.overflow;this.dialog.showModal();document.body.style.overflow='hidden';});
   this.querySelector('[data-guide-close]').addEventListener('click',()=>this.dialog.close());
   this.dialog.addEventListener('click',e=>{if(e.target!==this.dialog)return;const r=this.dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)this.dialog.close();});
   this.dialog.addEventListener('close',()=>{document.body.style.overflow=this.oldOverflow||'';this.querySelectorAll('iframe').forEach(f=>{const src=f.getAttribute('src');f.setAttribute('src',src);});this.trigger.focus({preventScroll:true});});
   this.querySelectorAll('[data-unit]').forEach(b=>b.addEventListener('click',()=>this.setUnit(b.dataset.unit,true)));
   this.querySelector('[data-guide-select]')?.addEventListener('change',e=>{this.querySelectorAll('[data-guide-panel]').forEach(p=>p.hidden=p.dataset.guidePanel!==e.target.value);this.setUnit(this.unit,false);});
  }
  addMeasurement(cell,text,base){
   if(!/\d/.test(text)||/\b(?:US|UK|EU|EUR)\b/i.test(text))return;
   const factor=base==='in'?2.54:base==='mm'?0.1:1;
   const convert=f=>text.replace(/\d+(?:\.\d+)?/g,n=>String(Math.round(Number(n)*f*100)/100)).replace(/\b(?:cm|mm|inch|inches)\b|["″]/gi,'').trim();
   this.measurements.set(cell,{cm:convert(factor),in:convert(factor/2.54)});
  }
  setUnit(unit,announce){
   this.unit=unit;this.measurements.forEach((v,cell)=>cell.textContent=v[unit]);
   this.querySelectorAll('[data-ulg-original-label]').forEach(h=>{h.textContent=h.dataset.ulgOriginalLabel.replace(/\bcm\b|\bmm\b|\b(?:in|inch|inches)\b/gi,unit==='cm'?'cm':'inches');});
   this.querySelectorAll('[data-unit]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.unit===unit)));
   const panel=this.querySelector('[data-guide-panel]:not([hidden])');
   const hasMeasurements=panel&&Array.from(this.measurements.keys()).some(c=>panel.contains(c));
   this.querySelector('[data-guide-toolbar]').hidden=!hasMeasurements;
   if(announce){this.querySelector('[data-guide-status]').textContent='Measurements shown in '+(unit==='cm'?'centimetres':'inches');try{localStorage.setItem('ulg-size-guide-unit',unit);}catch(_){}}
  }
  disconnectedCallback(){if(this.dialog?.open)this.dialog.close();}
 });
})();